import {Table, Tag, Tooltip} from "antd";
import dayjs from "dayjs";

const STATUS_MAP = {
	upcoming:    {label: 'Sắp diễn ra',  color: 'processing'},
	in_progress: {label: 'Đang diễn ra', color: 'blue'},
	overdue:     {label: 'Quá giờ',      color: 'orange'},
	trained:     {label: 'Đã đào tạo',   color: 'success'},
	not_trained: {label: 'Chưa đào tạo', color: 'error'},
	postponed:   {label: 'Đời lịch',     color: 'warning'},
	cancelled:   {label: 'Đã hủy',       color: 'default'},
};

const LEVEL_LABELS = {
	truong_phong: 'Trưởng phòng',
	quan_ly:      'Quản lý',
	nhom_truong:  'Nhóm trưởng',
};

function formatDateTime(ts) {
	if (!ts) return '—';
	return dayjs.unix(ts).format('DD/MM/YYYY HH:mm');
}

function renderAudience(record) {
	if (record.type === 'all') return 'Toàn bộ phòng KD';
	if (record.type === 'by_group' && record.groups?.length) {
		const names = record.groups.map(g => g.name).join(', ');
		return (
			<Tooltip title={names}>
				<span style={{cursor: 'help'}}>Theo phòng ({record.groups.length})</span>
			</Tooltip>
		);
	}
	if (record.type === 'by_level' && record.levels?.length) {
		const names = record.levels.map(l => LEVEL_LABELS[l] || l).join(', ');
		return (
			<Tooltip title={names}>
				<span style={{cursor: 'help'}}>Theo cấp ({record.levels.length})</span>
			</Tooltip>
		);
	}
	if (record.type === 'by_designation') {
		const designees = record.designees || [];
		if (designees.length) {
			const names = designees.map(u => `${u.firstname} ${u.lastname}`).join(', ');
			return (
				<Tooltip title={names}>
					<span style={{cursor: 'help'}}>Theo chỉ định ({designees.length})</span>
				</Tooltip>
			);
		}
		return 'Theo chỉ định';
	}
	return record.type || '—';
}

function TrainingReportTable({items = [], pagination = {}, onPaginationChange, loading}) {

	const columns = [
		{
			title: 'STT',
			key: 'stt',
			width: 55,
			render: (_, __, index) => (pagination.page - 1) * pagination.limit + index + 1,
		},
		{
			title: 'Chủ đề đào tạo',
			key: 'topic',
			render: (_, record) => record.topic || '—',
		},
		{
			title: 'Người đào tạo',
			key: 'trainer',
			width: 180,
			render: (_, record) => record.trainer
				? `${record.trainer.firstname} ${record.trainer.lastname}`
				: '—',
		},
		{
			title: 'Thời gian bắt đầu',
			key: 'startTime',
			width: 160,
			render: (_, record) => formatDateTime(record.startTime),
		},
		{
			title: 'Đối tượng',
			key: 'audience',
			width: 200,
			render: (_, record) => renderAudience(record),
		},
		{
			title: 'Trạng thái',
			key: 'status',
			width: 150,
			render: (_, record) => {
				const ds  = record.displayStatus || {};
				const cfg = STATUS_MAP[ds.key] || STATUS_MAP[record.status] || {label: record.status, color: 'default'};
				return <Tag color={cfg.color}>{cfg.label}</Tag>;
			},
		},
	];

	return (
		<div className="content-shadow pd-1 mt-0">
			<h4 style={{marginBottom: 12, fontWeight: 600}}>Danh sách chi tiết</h4>
			<Table
				columns={columns}
				dataSource={items}
				rowKey="id"
				loading={loading}
				pagination={{
					current:  pagination.page  || 1,
					pageSize: pagination.limit || 20,
					total:    pagination.total || 0,
					showTotal: (total) => `Tổng ${total} lịch đào tạo`,
				}}
				onChange={(pag) => { if (onPaginationChange) onPaginationChange(pag.current); }}
				scroll={{x: 900}}
			/>
		</div>
	);
}

export default TrainingReportTable;
